export default "__VITE_ASSET__H$$daEnb__"